import { rootInstance, axiosInstance } from '../axiosConfig';

const API_URL = 'empresas-confianza-public/';

export interface EmpresaConfianzaPublic {
    id: number;
    nombre: string;
    rubro: string;
    descripcion: string;
    logo: string | null;
    logo_alt: string;
    orden: number;
}

// 🔹 Obtener empresas activas (landing)
export const fetchEmpresasConfianzaPublic = async (): Promise<EmpresaConfianzaPublic[]> => {
    try {
        const response = await rootInstance.get(API_URL);
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.results)) return data.results;
        return [];
    } catch (err) {
        /* Browser diagnostics omitted. */
        const fallback = await axiosInstance.get(API_URL);
        const data = fallback.data;
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.results)) return data.results;
        return [];
    }
};